import React from "react";

import checkIcon from "../../assets/check-icon.svg";
import whiteCheckIcon from "../../assets/white-check-icon.svg";

import "./BulletPoint.scss";

const BulletPoint = ({ type, item }) => {
  return (
    <li className="bulletpoint__check-features">
      <div className="bulletpoint__features-icon">
        <img src={type === "regular" ? checkIcon : whiteCheckIcon} alt="" />
      </div>
      <div className="bulletpoint__text">{item}</div>
    </li>
  );
};

export default BulletPoint;
